import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite, Img } from '../../../../hybrid/wrappers';
import css from './Image.module.scss';

const Image = ({ val }) => {
    return (
        <div className={css.imageGrid}>
            {!val?.url && !val?.links?.thumb && !val?.links?.preview && !val?.links?.original ? (
                svgSprite('plug-product-image', {
                    width: '48px',
                    height: '48px'
                })
            ) : (
                <Img
                    className={css.imageGridItem}
                    src={val?.url || val?.links?.thumb || val?.links?.preview || val?.links?.original}
                    alt='image'
                />
            )}
        </div>
    );
};
Image.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    styles: PropTypes.object,
    name: PropTypes.string,
    link: PropTypes.string,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])
};
export default Image;
